module.exports = __webpack_public_path__ + "img/user.ca783559.svg";